import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import styles from "./NotFoundPage.module.css";

function NotFoundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.notFoundPage}>
      <Navbar />

      <div className={styles.contentContainer}>
        {/* Large Elegant Number */}
        <h1 className={styles.errorCode}>404</h1>

        {/* Sophisticated Message */}
        <h2 className={styles.title}>Page Not Found</h2>

        <p className={styles.message}>
          The page you are looking for does not exist or has been moved.
        </p>

        <Link to="/" className={styles.homeBtn}>
          Back to Home
        </Link>
      </div>

      <Footer />
    </div>
  );
}

export default NotFoundPage;
